import React, { useCallback } from "react";
import { withFormik } from 'formik';
import * as Yup from "yup";

// core components
import { Input } from "stories/forms";
import { Button, Link, Typography } from "stories/components"
import { Card, CardBody, CardHeader, Col, Row } from "stories/layout"

import { httpSendPasswordResetConfirmation } from "services/users"

const PasswordForgotForm = (props) => {
  const {
    values,
    touched,
    errors,
    handleChange,
    handleBlur,
    handleSubmit,
    isSubmitting,
    validateForm,
  } = props;
  
  const {
    t
  } = props;
  
  const getFormikInputProps = useCallback(
    name => ({
      name,
      value: values[name],
      error: Boolean(touched[name] && errors[name]),
      errorText: touched[name] ? errors[name] : "",
      onBlur: handleBlur,
      onChange: handleChange
    }),
    [values, errors, touched, handleBlur, handleChange]
  );
  
  return (
    <Card>
      <CardHeader className=" pt-5 pb-1">
        <div className="text-center text-muted mb-4">
          <Typography variant="h2" className="mb-2 ">{t("password_forgot_title","Unohtunut salasana")}</Typography>
          <Typography variant="p"></Typography>
        </div>
      </CardHeader>
      <CardBody className=" px-lg-5 py-lg-5">
        <Row>
          <Col className="mb-3">
            <Input
              {...getFormikInputProps("email")}
              label={t("password_forgot_email","Sähköposti")}
              type="email"
              required
            />
          </Col>
        </Row>
        
        <div className="text-center text-muted my-4">
          <Button variant="secondary" disabled={isSubmitting} onClick={() => validateForm().then(() => handleSubmit())}>{t("password_forgot_submit","Lähetä")}</Button>
          { Boolean(errors["general"]) && <Typography className="text-danger">{errors["general"]}</Typography> }
        </div>
        
        <Row>
          <Col className="mb-3 text-center">
            <Typography variant="small"><Link className="underline-text" to="/auth/login">{t("password_forgot_back_to_login","Takaisin kirjautumiseen")}</Link></Typography>
          </Col>
        </Row>
      </CardBody>
    </Card>
  );
}

const defaultValues = {
  email: '',
}

const PasswordForgotFormWithFormik = withFormik({
  validateOnMount: true,
  mapPropsToValues: props => {
    const { preSetValues } = props;
    if (preSetValues) {
      return preSetValues;
    } else {
      return defaultValues
    }
  },
  validationSchema: props => {
    const {t} = props;
    const required = t("required_field","Kenttä on pakollinen");
    
    return Yup.object().shape({
      email: Yup.string().email(t('validation_error_email','Tarkista sähköpostiosoitteen muoto')).required(required),
    });
  },
  handleSubmit: (values, { setSubmitting, setErrors, props }) => {
    const {t} = props;
    const data = {
      email: values?.email,
    }
    httpSendPasswordResetConfirmation(data).then(res => {
      setSubmitting(false);
      if (res?.status == 200) {
        props.handleResolve()
      }
      else {
        if (res?.data?.code == "user_not_found"){
          setErrors({
            general: t(res?.data?.detail),
          })
        }
        else {
          setErrors({
            general: `${JSON.stringify(res?.data)}`,
          })
        }
      }
    }, error => {
      setSubmitting(false);
      setErrors({
        general: `${t('unknown_error','Virhe. Ota tarvittaessa yhteys ylläpitoon.')} ${JSON.stringify(error)}`,
      })
    })
  },
  displayName: "PasswordForgotForm"
})(PasswordForgotForm);

export default PasswordForgotFormWithFormik; 